// ©2024 Austin App House. All rights reserved.
import { SET_MESSAGES_COUNTERS, SET_MESSAGES_SEEN } from "../actions/types";

const initialState = {
  unReadMessages:{}
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_MESSAGES_COUNTERS:
            return {
                ...state,
                unReadMessages: action.payload,
            };
        case SET_MESSAGES_SEEN: {
            const workOrderId = String(action.payload.workOrderId);
            if (!state.unReadMessages[workOrderId]) return state;
            return {
                ...state,
                unReadMessages: {
                    ...state.unReadMessages,
                    [workOrderId]: {
                        ...state.unReadMessages[workOrderId],
                        unread: 0,
                    },
                },
            };
        }
        default:
            return state;
    }
}
